// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import lriskEntity from './entities/lrisk.json';
import lriskMenu from '../pages/lrisk/menu.json';
import lriskFullForm from '../pages/lrisk/forms/full.json';
import lriskContextForm from '../pages/lrisk/forms/context.json';
import lriskMiniForm from '../pages/lrisk/forms/mini.json';
import lriskLookupForm from '../pages/lrisk/forms/lookup.json';
import lriskTableView from '../pages/lrisk/views/table.json';
import lriskStagesView from '../pages/lrisk/views/stages.json';
import lriskCardsView from '../pages/lrisk/views/cards.json';
import lriskInlineView from '../pages/lrisk/views/inline.json';
import lriskBacklogView from '../pages/lrisk/views/backlog.json';
import lriskSplitView from '../pages/lrisk/views/split.json';
import lriskCalendarView from '../pages/lrisk/views/calendar.json';
import lriskDashboardView from '../pages/lrisk/views/dashboard.json';

/** Тип запису «Правовий ризик» зі сторінками пакета: меню, форми та подання з pages/lrisk/. */
export const lriskDefinition: IRecordTypeDefinition = {
  ...lriskEntity,
  views: assembleViewSet({
      table: lriskTableView,
      stages: lriskStagesView,
      cards: lriskCardsView,
      inline: lriskInlineView,
      backlog: lriskBacklogView,
      split: lriskSplitView,
      calendar: lriskCalendarView,
      dashboard: lriskDashboardView,
  }),
  form: lriskFullForm,
  forms: { full: lriskFullForm, context: lriskContextForm, mini: lriskMiniForm, lookup: lriskLookupForm },
  menu: lriskMenu,
} as IRecordTypeDefinition;
